import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reauthoriseAuthorisedContact } from '../services/authorisedContacts';
import { agreementKeys } from './agreementKeys';

/** Never optimistic, for the same reason the revoke is not: the server owns the record. */
export function useReauthoriseAuthorisedContactMutation(id: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (contactId: string) => reauthoriseAuthorisedContact(id, contactId),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: agreementKeys.authorisedContacts(id) });
            void queryClient.invalidateQueries({ queryKey: agreementKeys.history(id) });
        },
    });
}
